// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nHHs","smallFormContainer":"styles_smallFormContainer__2tdGR"};